<template src="./CoreAssignModal.html">
</template>

<script>
/* testing */
export default {
  name: "assign-modal",
  data() {
    return {
    };
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
  },
  methods: {
    showConfirmationModal(confirmAction, cancelAction = () => {}, confirmParameter) {
      this.$bvModal.msgBoxConfirm(this.message, {
        title: this.title,
        centered: true
      })
      .then(value => {
        if (value) {
          confirmAction(confirmParameter);
        } else {
          cancelAction();
        }
      })
      // TODO handle error?
      .catch(error => console.log(error))
    }
  },
};
</script>
